import PageHead from "../../Head";
import Context from "@/context/Context";
import Footer from "@/my_components/Footer/Footer";
import HeaderContainer from "@/my_components/Header/HeaderContainer";
import CertificateVerify from "@/my_components/_Certificate/CertificateVerify";


const CertificateVerifyIndexPage = () => {
  return (
      <Context>
        <PageHead title="Verify a Certificate | SmartTech Academy" />
        <HeaderContainer headerSticky="rbt-sticky" headerType="" topBarToggle="off" />

        <CertificateVerify certificateNumber={null} />

        <Footer bg="dark" />
      </Context>
  );
};

export default CertificateVerifyIndexPage;
